//

const UUID_PATTERN =
  '[0-9a-fA-F]{8}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{12}';

const APP_ROUTES = {
  addAssessment: '/assessments/add',
  addActivityLab: '/activity-labs/add',
  addSubject: '/subjects/add/:gradeId?',
  assessments: '/assessments/:assessmentId?',
  assessmentResults: '/assessments/:assessmentId/results',
  assignments: '/assignments',
  assignedSkillBase: '/assignments/:assignmentId/subjects/:subjectId/skills/:skillId',
  assignedSkillOverview: '/assignments/:assignmentId/subjects/:subjectId/skills/:skillId/overview',
  assignedSkillQuestion:
    '/assignments/:assignmentId/subjects/:subjectId/skills/:skillId/questions/:questionId',
  assignedSkillWrapUp: '/assignments/:assignmentId/subjects/:subjectId/skills/:skillId/wrap-up',
  assignedSubject: '/assignments/:courseId',
  catchAll: '/',
  activityLabs: '/activity-labs',
  activityLabsQuizBase: '/activity-labs/:subjectId/quizzes/:skillId',
  activityLabsQuizOverview: '/activity-labs/:subjectId/quizzes/:skillId/overview',
  activityLabsQuizQuestion: '/activity-labs/:subjectId/quizzes/:skillId/questions/:questionId',
  activityLabsQuizWrapUp: '/activity-labs/:subjectId/quizzes/:skillId/wrap-up',
  activityLabsDetail: '/activity-labs/:subjectId',
  createAccount: '/create-account',
  createProfile: '/create-profile',
  currentAssignment: '/assignments/current',
  currentSubjectAssessment: '/subjects/:subjectId/assessments/current',
  essayDetail: '/study-support/essays/:essayId',
  essays: '/study-support/essays',
  essayUpload: '/study-support/essays/upload',
  home: '/',
  login: '/sign-in',
  orchestrator: '/orchestrator',
  onDemand: '/on-demand',
  onDemandCourse: '/on-demand/:slug',
  onDemandVideo: '/on-demand/:slug/video/:videoId',
  oops: '/oops',
  selectProfile: '/select-profile',
  sessionRecapChapter: '/session-recaps/:sessionId/chapters/:chapterId',
  sessionRecaps: '/session-recaps',
  sessionRecapsDetail: '/session-recaps/:sessionId',
  skillAnswers: '/students/:studentId/skills/:skillId/answers',
  skillBase: '/subjects/:subjectId/skills/:skillId',
  skillOverview: '/subjects/:subjectId/skills/:skillId/overview',
  skillPreview: '/skills/:skillId/preview',
  skillQuestion: '/subjects/:subjectId/skills/:skillId/questions/:questionId',
  skillWrapUp: '/subjects/:subjectId/skills/:skillId/wrap-up',
  standaloneAssessment: '/assessment/:assessmentId',
  standaloneAssessmentAnswers: '/assessment/:assessmentId/answers',
  standaloneAssessmentResults: '/assessment/:assessmentId/results',
  standardsResults: '/standards-results/:assessmentId',
  studentAgenda: '/agenda',
  studentAssignmentAnswers: '/students/:studentId/assignments/:assignmentId/answers',
  studentSkillAnswers: '/students/:studentId/skills/:skillId/answers',
  tutorChat: '/study-support/tutor-chat',
  subjects: '/subjects',
  subjectDetail: `/subjects/:subjectId(${UUID_PATTERN})`,
  unsupportedRole: '/unsupported',
};

const APP_ROUTE_GROUPS = {
  assignedSkillPractice: [
    APP_ROUTES.assignedSkillOverview,
    APP_ROUTES.assignedSkillQuestion,
    APP_ROUTES.assignedSkillWrapUp,
  ],
  activityLabs: [
    APP_ROUTES.activityLabsQuizOverview,
    APP_ROUTES.activityLabsQuizQuestion,
    APP_ROUTES.activityLabsQuizWrapUp,
  ],
  signIn: [APP_ROUTES.createAccount, APP_ROUTES.login],
  skillOverview: [
    APP_ROUTES.assignedSkillOverview,
    APP_ROUTES.activityLabsQuizOverview,
    APP_ROUTES.skillOverview,
  ],
  skillPractice: [
    APP_ROUTES.skillOverview,
    APP_ROUTES.skillQuestion,
    APP_ROUTES.skillWrapUp,
    APP_ROUTES.subjectDetail,
  ],
  skillQuestion: [
    APP_ROUTES.assignedSkillQuestion,
    APP_ROUTES.activityLabsQuizQuestion,
    APP_ROUTES.skillQuestion,
  ],
  skillWrapUp: [
    APP_ROUTES.assignedSkillWrapUp,
    APP_ROUTES.activityLabsQuizWrapUp,
    APP_ROUTES.skillWrapUp,
  ],
  unauthenticated: [
    APP_ROUTES.oops,
    APP_ROUTES.skillPreview,
    APP_ROUTES.standaloneAssessment,
    APP_ROUTES.standaloneAssessmentAnswers,
    APP_ROUTES.standaloneAssessmentResults,
    APP_ROUTES.standardsResults,
    APP_ROUTES.studentAssignmentAnswers,
    APP_ROUTES.studentSkillAnswers,
    APP_ROUTES.unsupportedRole,
  ],
};

// Exports
// -------

export { APP_ROUTES, APP_ROUTE_GROUPS };

export default APP_ROUTES;
